<script setup>
import ModalWrapper from '@/modals/ModalWrapper';
import { ref } from 'vue';
import { useStorageStore } from '@/stores/storage';

const props = defineProps({
    storage: {
        type: Object,
        default: () => ({
            name: '',
            type: 'short_term',
            is_active: true,
        })
    },
    mode: {
        type: String,
        default: 'Create'
    }
});

const emit = defineEmits(['close-modal', 'cancel-modal']);

const form = ref({
    name: props.storage.name,
    type: props.storage.type,
    is_active: props.storage.is_active,
});

const { storeStorage, updateStorage } = useStorageStore();

const save = async () => {
    try {
        if (props.mode === 'Create') {
            await storeStorage({
                name: form.value.name,
                type: form.value.type,
            });
        } else {
            await updateStorage({
                ...form.value,
                hash: props.storage.hash,
            });
        }

        emit('close-modal');
    } catch (error) {
        // The response interceptor surfaces the error toast
    }
};
</script>
<template>
<ModalWrapper @cancel-modal="emit('cancel-modal')">
    <template #header>{{ mode }} {{ $t('label.storage') }}</template>
    <template #subheader>{{ $t('label.create_or_edit', { what: $t('label.storage') }) }}</template>

    <form @submit.prevent="save">
        <div class="grid md:grid-cols-2 gap-x-4 gap-y-3">
            <StyledInput
                v-model="form.name"
                name="name"
                :placeholder="$t('label.name')"
                :label="$t('label.name')" />
            <StyledDropdown
                v-model="form.type"
                :options="[
                    { label: $t('label.short_term'), value: 'short_term' },
                    { label: $t('label.long_term'), value: 'long_term' },
                ]"
                name="type"
                :label="$t('label.type')"
                :placeholder="$t('label.type')" />
        </div>

        <StyledRoundSwitch
            v-if="mode === 'Edit'"
            v-model="form.is_active"
            :label="$t('label.active')"
            inset
            class="mt-2"
            name="is_active" />
    </form>

    <template #footer>
        <StyledSaveButton modal @save="save" />
    </template>
</ModalWrapper>
</template>
